import removeAccents from "remove-accents";

const getMemberFullName = (member) =>
    `${member?.firstname || ""} ${member?.lastname || ""}`.trim();

const normalizeText = (text) => removeAccents(text).toLowerCase();

export const sortMembersByName = (members) =>
    [...members].sort((a, b) =>
        getMemberFullName(a).localeCompare(getMemberFullName(b), "fr", {
            sensitivity: "base",
        })
    );

// Every typed word must appear in the full name, whatever their order.
export const filterMembersByQuery = (members, query) => {
    const words = normalizeText(query).split(/\s+/).filter(Boolean);
    if (words.length === 0) return members;
    return members.filter((member) => {
        const fullName = normalizeText(getMemberFullName(member));
        return words.every((word) => fullName.includes(word));
    });
};

export const haveSameMemberIds = (a, b) =>
    a.length === b.length && a.every((id) => b.includes(id));
